/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:20:41
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-03 17:39:29
 */
import { TableColumnType } from 'antd'
import React from 'react'

export const Columns = (
  onClick: (v: any,text?:any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '机构名称',
      dataIndex: 'tenantName',
      align: 'center',
    },
    {
      title: '所在地区',
      dataIndex: 'path',
      align: 'center',
      render: (_, t) => {
        return t.path ? t.path : '-'
      },
    },
    {
      title: '版本名称',
      dataIndex: 'versionName',
      align: 'center',
      render: (_, t) => {
        return t.versionName ? t.versionName : '-'
      },
    },
    {
      title: '1年价格',
      dataIndex: 'annualPrice',
      align: 'center',
      render: (_, t) => {
        return t?.annualPrice ? Number(t?.annualPrice)?.toFixed(2) : '0.00'
      },
    },
    {
      title: '价格状态',
      dataIndex: 'priceStatus',
      align: 'center',
      render: (_, t) => {
        return t?.priceStatus == '0'
          ? '未设置'
          : t?.priceStatus == '1'
          ? '已设置'
          : '-'
      },
    },
    {
      title: '操作',
      dataIndex: 'tenantCategory',
      align: 'center',
      render: function Element(_, t) {
        return <a onClick={() => onClick(t, 'setting')}>价格设置 </a>
      },
    },
  ]
}
